module.exports = {"360428100":"都昌镇","360428101":"周溪镇","360428102":"三汊港镇","360428103":"中馆镇","360428104":"大沙镇","360428105":"万户镇","360428106":"南峰镇","360428107":"土塘镇","360428108":"大港镇","360428109":"蔡岭镇","360428110":"徐埠镇","360428111":"左里镇","360428200":"和合乡","360428201":"阳峰乡","360428202":"西源乡","360428203":"芗溪乡","360428204":"狮山乡","360428205":"鸣山乡","360428206":"春桥乡","360428207":"苏山乡","360428208":"多宝乡","360428209":"汪墩乡","360428210":"北山乡","360428211":"大树乡","360428400":"江西省对外经济技术合作蔡岭示范区","360428500":"都昌县良种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360428.json
// module id = 1273
// module chunks = 0